// ----------------------------------------------------------------------
// <copyright file="Izenda.TenantItem.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
/**
 * Tenant Item component
 */
!(function () {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var classnames = require('classnames');
  var TextHighLight = require('share/components/controls/Izenda.TextHighLight');
  var constants = require('logic/data/Izenda.TenantConstants.js');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var actions = require('./Izenda.TenantItemAction');
  var config = require('config');

  var TenantItem = React.createClass({
    propTypes: {
      tenantInfo: React.PropTypes.object.isRequired
    },
    
    /**
     * Render tenant item component
     */
    render: function () {
      var props = this.props;
      var store = props.store;
      var tenantInfo = props.tenantInfo;
      var classes = classnames('item', 'truncate', { selected: props.tenantInfo.isSelected });
      var tenantStatus = tenantInfo.active ? constants.TENANT_STATE.DEACTIVATE : constants.TENANT_STATE.ACTIVATE;
      var authorization = props.authorization;
      var permissionKeys = props.authorizationConstants.PERMISSION_KEY;
      var hasEditPrivilege = authorization.checkPrivileges([permissionKeys.TenantSetupActionsEdit]);
      var hasDelPrivilege = authorization.checkPrivileges([permissionKeys.TenantSetupActionsDel]);
      var canDeleteTenant = hasDelPrivilege && !config.Integration;

      return (
          <div className={classes} onClick={props.handleSelected}>
            <GridLayout>
              <GridLayout.Row>
                <GridLayout.Col cols={6} className="overflow-text">
                  <TextHighLight
                             highlight={store.tenantList.filterText}
                             text={tenantInfo.displayName}
                             tooltip={tenantInfo.displayName}/>
                </GridLayout.Col>

                <GridLayout.Col cols={6}>
                  <div className='pull-right'>
                    {hasEditPrivilege && <a className={classnames('izenda-TenantStatus', {'izenda-TenantStatus-Deactivate' : tenantInfo.active})}
                       onClick={props.clickVisible}>
                        {tenantStatus}
                    </a>}
                    {canDeleteTenant && <span className='icon-cancel' onClick={props.clickDelete}/>}
                  </div>
                </GridLayout.Col>
              </GridLayout.Row>
            </GridLayout>
          </div>
      )
    }
  });

  module.exports = connect(actions)(TenantItem);
}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/TenantManagement/Izenda.TenantItem.jsx